import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { CitiService, SwiftForwardingApiClient } from '@sg/api/citi-service';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    PartnersAndClients: {
      entity: CitiService.RecipientDto;
      query: CitiService.RecipientSearchRequest;
    };
  }
}

export class PartnersAndClientsApiToEntityFetcherLink implements SgEntityFetchAdapter<'PartnersAndClients'> {
  readonly key: 'PartnersAndClients' = 'PartnersAndClients';
  readonly metadata: {
    idField: keyof CitiService.RecipientDto;
    labelField: Array<string>;
    queryField?: { field: keyof CitiService.RecipientSearchRequest; isArray?: boolean };
  } = {
    idField: 'id' as any,
    labelField: ['${company}', '/ ${custodianName}'],
    queryField: { field: 'custodianName', isArray: false },
  };

  private readonly swiftForwardingExternalApi: SwiftForwardingApiClient;

  constructor(injector: Injector) {
    this.swiftForwardingExternalApi = injector.get(SwiftForwardingApiClient);
  }

  getEntity(custodianName: string) {
    const body: CitiService.RecipientSearchRequest = { custodianName };
    return this.swiftForwardingExternalApi
      .swiftForwardingControllerPostSwiftSearchRecipients({ body }, { observe: 'body' })
      .pipe(map((results) => results.rows[0]));
  }

  findEntities(query?: CitiService.RecipientSearchRequest) {
    const body: CitiService.RecipientSearchRequest = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.swiftForwardingExternalApi
      .swiftForwardingControllerPostSwiftSearchRecipients({ body }, { observe: 'body' })
      .pipe(
        map((result: CitiService.RecipientDtoRecipientsOrderDtoPagingResultDto) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
